import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DialogData } from 'src/app/page/masterdata/apr-rates/apr-rates.component';
import { AprRatesService } from 'src/app/service/apr-rates.service';

@Component({
    selector: 'app-add-fiscal-year',
    templateUrl: './add-fiscal-year.component.html',
    styleUrls: ['./add-fiscal-year.component.scss'],
    standalone: false // NOSONAR
})
export class AddFiscalYearComponent implements OnInit {

  fiscalYear;
  usertemp: string;
  userInfo: any;
  strUserName;

  enableError: boolean = false;
  errormsg: string;
  action;

  dynamicHeight: number;

  constructor(private readonly ngxUiLoaderService: NgxUiLoaderService, private readonly aprRatesService: AprRatesService,
    @Inject(MAT_DIALOG_DATA) public dataStore: DialogData, private readonly dialogRef: MatDialogRef<AddFiscalYearComponent>) { 
      this.dynamicHeight = 0.665 * (window.innerHeight);
      this.ngxUiLoaderService.stop("loader-01");

      //fetch from local-storage
      // this.usertemp = localStorage.getItem('user-info');
      // this.userInfo = JSON.parse(this.usertemp);
      // this.strUserName = this.userInfo[0].strUserName;  // Commented fot taking the same info from APM

       this.usertemp = sessionStorage.getItem('FGA');
      this.userInfo = JSON.parse(this.usertemp);
      this.strUserName = this.userInfo?.user?.userPrincipalName;

      console.info(this.strUserName,"this.strUserName")

      if (this.dataStore.performAction == 'AddCell') { // NOSONAR
        this.action = 'AddCell';
      }
    }

  ngOnInit(): void { // NOSONAR 

  }

  onNoClick(): void {
		this.dialogRef.close();
	}

	close(): void {
		this.dialogRef.close();
	}

  public saveClick() {
    console.info("Fiscal Year", this.fiscalYear);
    console.info("User", this.strUserName);

    if (this.fiscalYear == '' || this.fiscalYear == null || this.fiscalYear == undefined) { // NOSONAR
      this.enableError = true;
      this.errormsg = 'Please fill in the required fields!';
    }
    else {
      this.dialogRef.close({
        event: this.action, data1: this.fiscalYear, data2: this.strUserName
      });
    }
  }
}
